// modules
import { NODE_ENV } from "@/config";
import {
  AppModule,
  AppointmentManagement,
  CommonModule,
  DashboardModule,
  OperationCalendarEventModule,
  OperationFormManagementModule,
  OperationMessageModule,
  OperationSchoolManagementModule,
  ParentInventory,
  ReferralAtModule,
  ReferralModule,
  StudentCompuHistoryModule,
  StudentEvaluationHistoryModule,
  StudentModule,
  StudentProvisionalRemedyAnswerModule,
  UbicationTechAssistanceMngmtModule,
  UserModule,
  AdmendmentModule,
  // eslint-disable-next-line prettier/prettier
  WelcomePortalModule,
  ProgramServiceModule
} from "@/modules";
import * as modules from "@/modules/";
import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";

export const modulesName = {
  ...modules.modulesName
};
Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: "vuex-student",
  storage: window.localStorage,
  reducer: state => ({
    selectedStudent: state.$_student.selectedStudent,
    details: state.$_student.details
  }), //only save navigation module
  filter: mutation =>
    ["$_student/setSelectedStudent", "$_student/clearSelectedStudent"].includes(
      mutation.type
    )
});

const UbicationTechAssistanceModulePersistence = new VuexPersistence({
  key: "vuex-uta-module",
  storage: window.localStorage,
  modules: ["ubication-tech-assistance-mngmt"]
});

const debug = NODE_ENV !== "production";
const store = new Vuex.Store({
  strict: debug,
  state,
  mutations,
  getters,
  actions,
  modules: {
    [modulesName.appModuleName]: AppModule,
    [modulesName.commonModuleName]: CommonModule,
    "student-evaluation-history": StudentEvaluationHistoryModule,
    parentInventory: ParentInventory,
    [modulesName.referralModuleName]: ReferralModule,
    "referral-at": ReferralAtModule,
    appointmentManagement: AppointmentManagement,
    [modulesName.studentProvisionalRemedyAnswerModuleName]: StudentProvisionalRemedyAnswerModule,
    [modulesName.welcomePortalModuleName]: WelcomePortalModule,
    [modulesName.programServiceModuleName]: ProgramServiceModule,
    [modulesName.studentCompuHistoryModuleName]: StudentCompuHistoryModule,
    [modulesName.dashboardModuleName]: DashboardModule,
    [modulesName.operationMessageModuleName]: OperationMessageModule,
    [modulesName.operationCalendarEventModuleName]: OperationCalendarEventModule,
    [modulesName.operationSchoolManagementModuleName]: OperationSchoolManagementModule,
    [modulesName.operationFormManagementModuleName]: OperationFormManagementModule,
    "ubication-tech-assistance-mngmt": UbicationTechAssistanceMngmtModule,
    [modulesName.userModuleName]: UserModule,
    [modulesName.AdmendmentModuleName]: AdmendmentModule,
    [modulesName.studentModuleName]: StudentModule
  },
  plugins: [vuexLocal.plugin, UbicationTechAssistanceModulePersistence.plugin]
});

export default store;
